import getPricingPlanModuleStatus from 'features/Onboarding/modules/PricingPlan/libs/getPricingPlanModuleStatus';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep, VerificationStepCategory } from './types';

const getPlanBrandName = (planId: string | null) => {
  if (!planId) {
    return '';
  }

  return `${planId.slice(0, 1).toUpperCase()}${planId.slice(1)}`;
};

const getPricingPlanStep: GetVerificationStep = (moduleData) => {
  const { applicantType, verificationData } = moduleData;
  const { metadata: companyMetadata } = verificationData.viewer.company;

  const status = getPricingPlanModuleStatus({ applicantType, companyMetadata });

  return {
    errors: [],
    id: State.PRICING_PLAN,
    metadata: {
      category: VerificationStepCategory.ShineOffer,
      description: {
        review: locales.formatString(locales.pricingPlan.description.review, {
          plan: getPlanBrandName(companyMetadata.selectedPlanId),
        }),
      },
      event: model.events.GO_PRICING_PLAN(),
      iconName: 'card-recto',
      label: locales.pricingPlan.label,
    },
    status,
  };
};

export default getPricingPlanStep;
